var _circle, _path, _path2, _path3, _path4, _path5, _path6, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeStudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 14,
    fill: "#dd2c00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M27.133,5h-6.265c-0.498,0-0.92,0.366-0.99,0.859L19,12h10l-0.877-6.141 C28.052,5.366,27.63,5,27.133,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M9.112,11.787l-3.133,5.426C5.73,17.644,5.836,18.192,6.228,18.5l4.88,3.831l5-8.66l-5.757-2.311 C9.889,11.174,9.361,11.356,9.112,11.787z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M5.979,30.787l3.133,5.426c0.249,0.431,0.777,0.613,1.239,0.428l5.757-2.311l-5-8.66L6.228,29.5 C5.836,29.808,5.73,30.356,5.979,30.787z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M20.867,43h6.265c0.498,0,0.92-0.366,0.99-0.859L29,36H19l0.877,6.141 C19.948,42.634,20.37,43,20.867,43z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M38.888,36.213l3.133-5.426c0.249-0.431,0.143-0.979-0.249-1.287l-4.88-3.831l-5,8.66l5.757,2.311 C38.111,36.826,38.639,36.644,38.888,36.213z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd2c00",
    d: "M42.021,17.213l-3.133-5.426c-0.249-0.431-0.777-0.613-1.239-0.428l-5.757,2.311l5,8.66l4.88-3.831 C42.164,18.192,42.27,17.644,42.021,17.213z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "20,18 20,30 30,24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeStudio);
export default __webpack_public_path__ + "static/media/youtubeStudio.e47384274f49629d0d3b816bdcfdc02a.svg";
export { ForwardRef as ReactComponent };